import React, { useState } from 'react';
import Button from '../common/Button';
import WalletModal from './WalletModal';

export default function ConnectButton({ block = false, size = 'md' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button neon block={block} size={size} onClick={() => setOpen(true)}>
        Connect Wallet
      </Button>
      <WalletModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
